export enum SurveyQuestionChoiceTypeEnum {
    DROPDOWN = 'dropdown',
    STRING = 'string',
    NUMBER = 'number',
    DATE = 'date',
    SCALE = 'scale',
    BOOLEAN = 'bool'
}